var map = {
	"./Banner_dashboard 1.svg": "fbb6",
	"./Banner_dashboard.svg": "7540",
	"./Banner_dashboard2.svg": "8bea",
	"./banner1.png": "1af9",
	"./banner2.png": "b2bd",
	"./bannerLoginPageMobile.png": "c5f4",
	"./capa.png": "3177",
	"./capa2.jpeg": "1918",
	"./whiteLogo-61.png": "de4f",
	"./whiteLogo.png": "80a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ac5";